import { z } from "zod";

import { OtherDocumentType } from "@/src/models/constants/document-types";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { DocumentDateSchema } from "@/src/models/documents/document-dates";
import { Patient, patientMinimalSchema } from "@/src/models/patient";

export const otherTypeDisplay: Record<OtherDocumentType, string> = {
  [OtherDocumentType.OTHER]: "Other",
};

export const otherSchema = z.object({
  patient: patientMinimalSchema,
  dateReceived: DocumentDateSchema.shape.dateReceived,
  documentType: z.string().nullable(),
});

export type Other = Omit<z.infer<typeof otherSchema>, "patient"> & {
  patient: Patient | null;
} & DatabaseDefaults;

export const otherShape: Other = {
  id: "",
  patient: null,
  dateReceived: null,
  documentType: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
};
